import React from 'react';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { OutcomeTile } from 'web-ui-components/lib/layout/content';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import { getHyperlink } from '../../utils';

const SecondaryApplicantWaitingPage = ({ bankId }) => (
  <div>
    <Content>
      {({
        submittedPageTitle = '',
        submittedContentA,
        submittedContentB,
        moreBusinessProductLinkText,
        moreBusinessProductLink,
        moreBusinessProductLinkYB
      }) => (
        <StandardBody>
          <OutcomeTile.Success headingText={submittedPageTitle} />
          <p>{submittedContentA}</p>
          <p>{submittedContentB}</p>
          <WebsiteLink
            linkText={moreBusinessProductLinkText}
            url={getHyperlink(moreBusinessProductLink, moreBusinessProductLinkYB, bankId)}
            willOpenNewWindow
          />
        </StandardBody>
      )}
    </Content>
  </div>
);

SecondaryApplicantWaitingPage.propTypes = {
  bankId: PropTypes.bankId.isRequired
};

export default SecondaryApplicantWaitingPage;
